import React, { useState, useEffect } from 'react';

const FilterAssistenciaComponent = ({ dados, onChange }) => {
    const [uniqueRedes, setUniqueRedes] = useState([]);
    const [selectedRede, setSelectedRede] = useState('CRAS');

    useEffect(() => {
        const redesSet = new Set(dados.map(item => item.rede));
        setUniqueRedes(Array.from(redesSet));
    }, [dados]);

    const handleRedeChange = (e) => {
        const selectedRede = e.target.value;
        setSelectedRede(selectedRede);
        onChange(selectedRede); 
    };

    return (
        <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <select
                style={{
                    width: '100%',
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                }}
                value={selectedRede}
                onChange={handleRedeChange}
            >
                <option value="">REDE</option>
                {uniqueRedes.map((rede, index) => (
                    <option key={index} value={rede}>{rede}</option>
                ))}
            </select>
        </div>
    );
};

export default FilterAssistenciaComponent;
